<template>
  <div :style="'background-color:' + $bgColor + ';height: 95px;'">
    <div
      @click="$router.go(-1)"
      :style="
        'z-index: 0;font-size: 20px;font-weight: bold;position: relative;height:95px;padding:15px;background-color:' +
          $bgColor + 'color:' + $CUSTOMMainTextColor
      "
      fixed
      dense
    >
      <v-icon>mdi-chevron-left</v-icon>{{ $t("message.allLevel") }}
    </div>
    <div>
      <!-- <div style="display:flex;align-items:center;justify-content:flex-end;padding:8px 0;">
        <v-btn small text @click="showApiResponse = !showApiResponse">
          {{ showApiResponse ? 'Hide debug' : 'Show debug' }}
        </v-btn>
      </div> -->
      <div style="height: 100vh;">
        <v-tabs v-if="level && level.length" v-model="tab" :background-color="levelById.color" :color="HEXToVBColorLMG(levelById.color)"
        :style="{'color': HEXToVBColorLMG(levelById.color)}" show-arrows>
          <v-tab
            v-for="(item, index) in level"
            :key="index"
            :href="'#tab-' + index"
            :style="{'color': HEXToVBColorLMG(levelById.color)}"
             :color="HEXToVBColorLMG(levelById.color)"
          >

            {{ item.name }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-if="level && level.length" :Style="$isTargetShop? '#':$bgColor" v-model="tab">
          <v-tab-item
            v-for="(item, index) in level"
            :key="index"
            :value="'tab-' + index"
             :background-color=" $isTargetShop ? '#00000000' : levelById.color"
             :color="$isTargetShop? '#fff': $bgColor"
          >
            <v-card flat>
              <v-card-text>
                <v-container class="pa-6">
                  <h4>{{ item.name }}</h4>
                  <v-row>
                    <v-col class=" font16 bold" :style="{'color':$CUSTOMMainTextColor}">{{
                      $t("message.privilegeDetail")
                    }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                    <!-- {{ item }} -->
                      <nl2br :class="{ 'target-shop-color': $isTargetShop }"
:style="{ color: !$isTargetShop ? $CUSTOMMainTextColor : undefined }" tag="p" :text="item.priviledge || ' '"></nl2br>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>
<script>
import MenuItem from '../../MenuItem'
import { mapGetters } from 'vuex'

export default {
  components: {
    'menu-item': MenuItem
  },
  data () {
    return {
      level: [],
      levelById: null,
      tab: null,
      shopId: null,
      showApiResponse: false,
      text:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    }
  },
  computed: {
    isTargetShop () {
      return this.$isTargetShop()
    },
    tabTextColor () {
      // If levelById.color is white-tone, force black text
      if (this.levelById && this.levelById.color) {
        try {
          if (this.isWhiteTone(this.levelById.color)) return '#000000'
        } catch (e) {
          // fall through
        }
      }
      // fallback to existing behavior: if target shop use contrast, else use background color
      if (this.$isTargetShop()) {
        return this.levelById && this.levelById.color ? '#000000' : '#ffffff'
      }
      return this.$bgColor || '#000000'
    }
  },
  async mounted () {
    this.shopId = this.GET_SHOPID()
    // fetch fresh levels from backend to ensure up-to-date list (show all levels)
    try {
      const resp = await this.callBeTaskAPI('get', '/level/line/get?RECORD_STATUS=N')
      if (resp && resp.length) {
        // sort by point (if available) for stable ordering
        this.level = resp.slice().sort((a, b) => {
          const pa = Number(a.point || 0)
          const pb = Number(b.point || 0)
          return pa - pb
        })
        this.tab = 'tab-0'
      } else {
        // fallback to store getter if API returns nothing
        this.level = await this.GET_LEVEL()
      }
    } catch (e) {
      console.error('Failed to fetch levels from API', e)
      this.level = await this.GET_LEVEL()
    }

    await this.getLevelById()
  },
  methods: {
    ...mapGetters('shopStore', ['GET_LEVEL', 'GET_SHOPID']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    async getLevelById () {
      let member = this.GET_MEMBERINFO()
      const result = await this.callBeTaskAPI(
        'get',
        `/level/getID?RECORD_STATUS=N&levelId=${member.levelId}`
      )
      if (result) {
        this.levelById = result
      } else {
        this.levelById = null
      }
    },
    normalizeHex (hex) {
      if (!hex) return null
      let h = String(hex).trim().toLowerCase()
      if (h.startsWith('rgb')) return null
      if (h[0] === '#') h = h.slice(1)
      if (h.length === 3) h = h.split('').map(c => c + c).join('')
      if (h.length !== 6) return null
      return h
    },
    isWhiteTone (color) {
      const h = this.normalizeHex(color)
      if (!h) return false
      const r = parseInt(h.slice(0, 2), 16)
      const g = parseInt(h.slice(2, 4), 16)
      const b = parseInt(h.slice(4, 6), 16)
      // perceived brightness
      const brightness = (r * 299 + g * 587 + b * 114) / 1000
      // threshold: very light colors considered 'white-tone'
      return brightness >= 240
    }
  }
}
</script>
<style scoped>
p {
  margin-bottom: 0;
  margin: auto;
}
a.v-tab {
  text-decoration: none;
}
.target-shop-color {
  color: #000 !important;
}

/* Ensure the color applies to the <p> rendered inside the nl2br child component */
.target-shop-color ::v-deep p {
  color: #000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Card/C/TierBenefit.vue